import React, { useCallback, ComponentProps, useState } from 'react';
import { PaymentSource } from '../../constants';
import { useCountry } from '../CountrySelector';
import { AmazonPayButton } from '../PaymentSourceButton';
import { useOrderDetails } from '../OrderDetails';
import { useOrderDetailsPaymentSource } from './useOrderDetailsPaymentSource';

type Props = Omit<ComponentProps<typeof AmazonPayButton>, 'onSelect'>;

export const useIsAmazonPaySupported = () => {
  const {
    country: { currencyCode }
  } = useCountry();
  const { orderSummary } = useOrderDetails();

  return currencyCode === 'USD' && orderSummary?.attributes.isAmazonSupported;
};

export const OrderDetailsAmazonPayButton: React.FC<Props> = props => {
  const [loading, setLoading] = useState(false);
  const isAmazonPaySupported = useIsAmazonPaySupported();
  const { changePaymentSource } = useOrderDetailsPaymentSource();

  const onSelect = useCallback(() => {
    setLoading(true);
    changePaymentSource(PaymentSource.Amazon);
  }, [changePaymentSource]);

  if (!isAmazonPaySupported) return null;

  return <AmazonPayButton {...props} isLoading={loading} onSelect={onSelect} />;
};
